import styled from "styled-components";
import { colors } from "@pepdirect/v3/styles/variables";

export const StyledBreadcrumbs = styled.div`
  size: 16px;
  color: ${colors.gray900};
  font-weight: 500;
  margin: 24px;

  overflow: hidden;
  text-overflow: ellipsis;
  > span {
    margin-right: 10px;
  }
  span {
    text-decoration: none;
  }
`;

export const StyledBreadcrumbLink = styled.span`
  text-decoration: underline;
`;

export const StyledCaret = styled.span`
  margin-left: 10px;
`;
